import React, { useEffect, useState, useCallback } from 'react';

const WMO_ICONS = {
  clearsky_day: '☀️', clearsky_night: '🌙', clearsky_polartwilight: '🌅',
  fair_day: '🌤️', fair_night: '🌤️', fair_polartwilight: '🌤️',
  partlycloudy_day: '⛅', partlycloudy_night: '⛅', partlycloudy_polartwilight: '⛅',
  cloudy: '☁️',
  rainshowers_day: '🌦️', rainshowers_night: '🌧️', rainshowers_polartwilight: '🌦️',
  rainshowersandthunder_day: '⛈️', rainshowersandthunder_night: '⛈️',
  sleetshowers_day: '🌨️', sleetshowers_night: '🌨️',
  snowshowers_day: '🌨️', snowshowers_night: '🌨️',
  rain: '🌧️', heavyrain: '🌧️', heavyrainandthunder: '⛈️',
  sleet: '🌨️', snow: '❄️', heavysnow: '❄️',
  fog: '🌫️',
  lightrainshowers_day: '🌦️', lightrainshowers_night: '🌧️',
  lightrain: '🌧️', lightrainandthunder: '⛈️',
  heavyrainshowers_day: '🌧️', heavyrainshowers_night: '🌧️',
  lightsleet: '🌨️', lightsnow: '🌨️',
};

const DEFAULT_LOCATION = { name: 'Moelv', lat: 60.9333, lon: 10.6944 };

const WeatherHeaderChip = () => {
  const [weather, setWeather] = useState(null);
  const [location, setLocation] = useState(() => {
    const saved = localStorage.getItem('weather_location');
    return saved ? JSON.parse(saved) : DEFAULT_LOCATION;
  });

  const getIcon = (symbolCode) => WMO_ICONS[symbolCode] || '🌡️';

  const fetchWeather = useCallback(async (loc) => {
    try {
      const res = await fetch(
        `https://api.met.no/weatherapi/locationforecast/2.0/compact?lat=${loc.lat}&lon=${loc.lon}`,
        { headers: { 'User-Agent': 'Produksjonsstyring/1.0 github.com/produksjonsstyring' } }
      );
      if (!res.ok) return;
      const data = await res.json();
      const ts = data.properties?.timeseries || [];
      if (ts.length > 0) {
        const now = ts[0];
        const instant = now.data.instant.details;
        const next1h = now.data.next_1_hours || now.data.next_6_hours;
        setWeather({
          temp: Math.round(instant.air_temperature),
          symbol: next1h?.summary?.symbol_code || 'cloudy',
        });
      }
    } catch (e) {
      // silent fail
    }
  }, []);

  useEffect(() => {
    fetchWeather(location);
    const interval = setInterval(() => fetchWeather(location), 600000);
    return () => clearInterval(interval);
  }, [location, fetchWeather]);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'weather_location') {
        try { setLocation(JSON.parse(e.newValue)); } catch {}
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  if (!weather) return null;

  return (
    <div
      className="tw-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-rounded-xl tw-flex-shrink-0"
      title={`Vær i ${location.name} — Data fra MET Norway / yr.no`}
      style={{ background: 'rgba(0,0,0,0.04)', border: '1px solid rgba(0,0,0,0.08)' }}
    >
      <span style={{ fontSize: '1.1rem', lineHeight: 1 }}>{getIcon(weather.symbol)}</span>
      <span className="tw-text-sm tw-font-bold tw-text-gray-800">{weather.temp}°</span>
      <span className="tw-text-[10px] tw-hidden md:tw-inline" style={{ color: '#64748b' }}>{location.name}</span>
    </div>
  );
};

export default WeatherHeaderChip;
